var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgE911Emergency24Dp434343Fill0Wght400Grad0Opsz24 = function SvgE911Emergency24Dp434343Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#434343",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-160v-80h64l79-263q8-26 29.5-41.5T420-560h120q26 0 47.5 15.5T617-503l79 263h64v80zm148-80h264l-72-240H420zm92-400v-200h80v200zm238 99-57-57 142-141 56 56zm42 181v-80h200v80zM282-541 141-683l56-56 142 141zM40-360v-80h200v80zm440 120"
  })));
};
export default SvgE911Emergency24Dp434343Fill0Wght400Grad0Opsz24;